<template>
  <div>
    <div class="m-b-40 clear-float">
      <div class="m-b-20 clear-float">
        <div class="col-xs-3">
          <InputText
            :label="$t('awb')"
            v-model="value.trace_no"
            :rules="{required: true}" />
        </div>
        <div class="col-xs-3">
          <InputSelect
            :label="$t('goods_type')"
            v-model="value.goodsType"
            :options="goodsTypeSelection"
            :rules="{required: true}" />
        </div>
        <div class="col-xs-3">
          <InputSelect
            :label="$t('shipping_agent_name')"
            v-model="value.shippingAgentId"
            :options="shippingAgents"
            :rules="{required: true}"
            @change="setAgentShippingProducts"
          />
        </div>
        <div class="col-xs-3">
          <InputSelect
            :label="$t('products')"
            v-model="value.shippingProductId"
            :options="agentShippingProducts"
            :rules="{required: true}" />
        </div>
      </div>
      <div>
        <div class="col-xs-4">
          <WeightSelect
            :label="$t('weight')"
            v-model="value.weight"
          />
        </div>
        <div class="col-xs-8">
          <DimensionsSelect
            v-model="value.dimensions" />
        </div>
      </div>
    </div>
    <div class="clear-float m-l-10">
      <Btn
        v-if="deletable"
        @click.native="deleteRow"
        class="gray float-left m-r-20"
        :icon="{
            name: 'deleteForever',
            size: '18',
          }"
        :btnText="$t('delete')"
      />
    </div>
    <div class="separator" style="width: 100%"></div>
  </div>
</template>

<script>
/* eslint-disable */
import InputText from '@/components/elements/inputs/text.vue';
import InputSelect from '@/components/elements/inputs/select.vue';
import mixin from "@/mixins/mixins";
import Btn from "@/components/elements/buttons/button";
import Toggle from "@/components/elements/inputs/toggle";
import DimensionsSelect from "@/components/elements/inputs/dimensionsSelect";
import WeightSelect from "@/components/elements/inputs/weightSelect";
import NestedSelect from "@/components/elements/inputs/nestedSelect";
import {mapGetters} from "vuex";

export default {
  name: 'ManualShipmentRow',
  mixins: [mixin],
  components: {
    Btn,
    InputSelect,
    InputText,
    Toggle,
    DimensionsSelect,
    WeightSelect,
    NestedSelect,
  },
  props: {
    indexInData: {
      type: Number,
      default: 1
    },
    shippingProducts: {
      type: Array,
      default: []
    },
    shippingAgents: {
      type: Array,
      default: []
    },
    deletable: {
      type: Boolean,
      default: false
    },
    value: {
      type: Object,
      default: () => {
        return {
          shippingAgentId: '',
          shippingProductId: '',
          trace_no: '',
          goodsType: 1,
          weight: {
            value: 0,
            unit: 'kg',
          },
          dimensions: {
            width: {
              value: 0,
              disabled: false,
            },
            height: {
              value: 0,
              disabled: false,
            },
            length: {
              value: 0,
              disabled: false,
            },
            dimensionsType: '',
          },
        }
      },
    },
  },
  data() {
    return {
      agentShippingProducts: [],
    }
  },
  computed: {
    ...mapGetters([
      'get_shipping_agents_select',
    ]),
  },
  mounted () {
  },
  methods: {
    setAgentShippingProducts(agentId) {
      const key = `agent-${agentId}`;
      this.agentShippingProducts = this.shippingProducts[key];
    },
    deleteRow(index) {
      this.$emit('deleteRow', index);
    },
  },
  watch: {
  },
}
</script>
